<template>

    <q-card-section class="q-pa-sm text-brand7 q-pb-md bg-grey-2">
      <div class="q-px-sm">
        <span class="semi-bordered-bottom text-bold">Load board overview</span>
      </div>

      <div>
        <div
            v-if="(loadBoardForOrder?.httpCode??-1) === 0"
            class="row"
        >
          <div class="col-12 text-center">
            No load board connected
          </div>
        </div>

        <div
            v-if="((loadBoardForOrder?.httpCode??-1) >= 400) && ((loadBoardForOrder?.httpCode??-1) < 500)"
            class="row"
        >
            <div class="col-12 text-negative text-center">
              {{loadBoardForOrder.listingId}} was deleted remotely, but is still connected to the order
            </div>
        </div>

        <div
            class="row"
            v-if="((loadBoardForOrder?.httpCode??-1) >= 200) && ((loadBoardForOrder?.httpCode??-1) < 400)"
        >

              <div>
                {{loadBoardForOrder.listingId}} is the current order.
              </div>


              <div v-if="loadBoardForOrder.createdOn" class="col-12 col-sm-6 col-lg-3">
                Created on
                {{
                  loadBoardForOrder.createdOn | localTime
                }}
              </div>

              <div v-if="loadBoardForOrder.expirationDate" class="col-12 col-sm-6 col-lg-3">
                Expires on
                {{
                  loadBoardForOrder.expirationDate | localTime
                }}
              </div>

              <div v-if="loadBoardForOrder.listingStatus" class="col-12 col-sm-6 col-lg-3">
                Status
                {{ loadBoardForOrder.listingStatus }}
              </div>

              <div v-if="loadBoardForOrder.totalDistanceInMiles" class="col-12 col-sm-6 col-lg-3">
                {{ loadBoardForOrder.totalDistanceInMiles }} miles
              </div>

        </div>
      </div>
    </q-card-section>

</template>

<script>
import graphql from '@client/graphql';

export default {
  name: 'AppLoadBoardOverview',
  props: ['orderId','parentStatus'],
  apollo: {
    loadBoardForOrder: {
      query: graphql.queries.getLoadBoardForOrder,
      variables() {
        return { orderId: parseInt(this.orderId.toString()) };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      }
    }
  },
  data() {
    return {
      loading: false
    };
  }
};
</script>

